<template>
	<div class="menus-wrap">
		<p class="title">{{examination_name}}</p>
		<p class="title">成绩通知单</p>
		<div class="wrap">
			<el-descriptions title="" :column="1" border>
				<el-descriptions-item label="姓名" 
					:labelStyle="{width:'250px', background: '#CCFFFF', 'text-align': 'center', color: '#000000', border: '1px solid transparent', borderColor: '#000000'}"
					:contentStyle="{border: '1px solid transparent', borderColor: '#000000'}"> {{info.name}} </el-descriptions-item>
				<el-descriptions-item label="身份证号" 
					:labelStyle="{background: '#CCFFFF', 'text-align': 'center', color: '#000000', border: '1px solid transparent', borderColor: '#000000'}"
					:contentStyle="{border: '1px solid transparent', borderColor: '#000000'}"> {{info.card_id}} </el-descriptions-item>
				<el-descriptions-item label="准考证号" 
					:labelStyle="{background: '#CCFFFF', 'text-align': 'center', color: '#000000', border: '1px solid transparent', borderColor: '#000000'}"
					:contentStyle="{border: '1px solid transparent', borderColor: '#000000'}"> {{info.number}} </el-descriptions-item>
				<el-descriptions-item label="报考单位" 
					:labelStyle="{background: '#CCFFFF', 'text-align': 'center', color: '#000000', border: '1px solid transparent', borderColor: '#000000'}"
					:contentStyle="{border: '1px solid transparent', borderColor: '#000000'}"> {{info.department_name}} </el-descriptions-item>
				<el-descriptions-item label="报考岗位" 
					:labelStyle="{background: '#CCFFFF', 'text-align': 'center', color: '#000000', border: '1px solid transparent', borderColor: '#000000'}"
					:contentStyle="{border: '1px solid transparent', borderColor: '#000000'}"> {{info.position_name}} </el-descriptions-item>
					
				<el-descriptions-item label="笔试成绩" 
					:labelStyle="{background: '#CCFFFF', 'text-align': 'center', color: '#000000', border: '1px solid transparent', borderColor: '#000000'}"
					:contentStyle="{border: '1px solid transparent', borderColor: '#000000'}"> {{info.com_sub}} </el-descriptions-item>
				<el-descriptions-item label="是否进入资格复审" 
					:labelStyle="{background: '#CCFFFF', 'text-align': 'center', color: '#000000', border: '1px solid transparent', borderColor: '#000000'}"
					:contentStyle="{border: '1px solid transparent', borderColor: '#000000'}"> {{info.com_score}} </el-descriptions-item>
				<!--
				<el-descriptions-item label="名称" 
					:labelStyle="{background: '#CCFFFF', 'text-align': 'center', color: '#000000', border: '1px solid transparent', borderColor: '#000000'}"
					:contentStyle="{border: '1px solid transparent', borderColor: '#000000'}"> {{info.manage_sub}} </el-descriptions-item>
				<el-descriptions-item label="名称" 
					:labelStyle="{background: '#CCFFFF', 'text-align': 'center', color: '#000000', border: '1px solid transparent', borderColor: '#000000'}"
					:contentStyle="{border: '1px solid transparent', borderColor: '#000000'}"> {{info.manage_score}} </el-descriptions-item>
				<el-descriptions-item label="名称" 
					:labelStyle="{background: '#CCFFFF', 'text-align': 'center', color: '#000000', border: '1px solid transparent', borderColor: '#000000'}"
					:contentStyle="{border: '1px solid transparent', borderColor: '#000000'}"> {{info.total_score}} </el-descriptions-item>
				<el-descriptions-item label="名称" 
					:labelStyle="{background: '#CCFFFF', 'text-align': 'center', color: '#000000', border: '1px solid transparent', borderColor: '#000000'}"
					:contentStyle="{border: '1px solid transparent', borderColor: '#000000'}"> {{info.standard}} </el-descriptions-item>
				<el-descriptions-item label="名称" 
					:labelStyle="{background: '#CCFFFF', 'text-align': 'center', color: '#000000', border: '1px solid transparent', borderColor: '#000000'}"
					:contentStyle="{border: '1px solid transparent', borderColor: '#000000'}"> {{info.seniority}} </el-descriptions-item>
					-->
			</el-descriptions>
		</div>
	</div>
</template>

<script>
import { reqGetCandidateScore,reqLoginName } from '@/api';
import {mapGetters, mapState} from 'vuex';
export default {
	data() {
		return {
			info: {},
		};
	},
	computed: {
		...mapState({
			refresh: state => state.system.refresh,
			unitName: state => state.system.unitName,
			examination_name: state => state.system.examInfo.examination_name,
		}),
	},
	activated(){
		if(!this.refresh) {
			this.$store.commit('system/SET_REFRESH', 1);
			window.location.href = `${window.location.origin}${window.location.pathname}?${Date.now()}`;
			return;
		}
		this.getScore();
	},
	methods: {
		getScore() {
			reqGetCandidateScore().then(res => {
				this.$store.commit('system/SET_REFRESH', 1);
				this.info = res.data;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.menus-wrap {
	display: flex;
	flex-direction: column;
	align-items: center;
	.title {
		margin-top: 50px;
		font-size:24px;
	}
	.wrap {
		width: 800px;
		margin-top: 20px;
		color: #1a222e;
		.info {
			display: flex;
			align-items: center;
			justify-content: space-between;
			> span + span {
				margin-left: 50px;
			}
		}

	::v-deep.el-descriptions {
		padding: 0 5px;

		.el-descriptions__body {
			.el-descriptions__table .el-descriptions-item__cell {
				font-size:20px;
				border: 1px solid;
				borderColor: #000000;
				color: #000000;
			}
		}
	}
	}
}
</style>
